import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgBeautySolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.53 3.47a.75.75 0 00-1.06 0C9.359 5.58 8.567 7.723 8.333 9.855a.75.75 0 00.284.673 10.754 10.754 0 012.73 3.163.75.75 0 001.305 0 10.748 10.748 0 012.731-3.163.75.75 0 00.284-.673c-.233-2.132-1.026-4.274-3.136-6.385zM22.622 10.618a.75.75 0 00-.751-.867 9.25 9.25 0 00-9.12 9.132.75.75 0 00.858.752c4.951-.722 8.33-4.702 9.013-9.017zM2.13 9.75a.75.75 0 00-.752.868c.683 4.315 4.062 8.295 9.013 9.017a.75.75 0 00.858-.752A9.251 9.251 0 002.13 9.75z",
    fill: "currentColor"
  })));
}

export { SvgBeautySolid as ReactComponent };
